<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="avaliacoes"
      :sort-by="[{ key: 'id', order: 'asc' }]"
      :search="search"
      class="elevation-1"
    >
      <template #top>
        <v-toolbar flat>
          <v-btn
            style="background: #f9f8f8; font-size: 18px"
            size="small"
            @click="this.$router.push('/projects')"
            icon
          >
            <v-icon color="#004984">mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title style="font-size: 22px; font-weight: bold"
            >{{ nomeProjeto }} - Avaliações</v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            outline
            hide-details
            variant="underlined"
          ></v-text-field>
        </v-toolbar>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="justify-content-end">
          <v-btn
            prepend-icon="mdi-star-shooting-outline"
            variant="text"
            @click="callViewRatingIndividual(item.raw)"
          >
            Pontuação Individual
          </v-btn>
          <v-btn
            prepend-icon="mdi-star-shooting-outline"
            variant="text"
            @click="callViewRating(item.raw)"
          >
            Pontuação
          </v-btn>
        </div>
      </template>
      <template #no-data>
        <div class="text-center py-6">
          <span> Sem avaliações a listar </span>
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import axios from 'axios';
import { VDataTable } from 'vuetify/labs/VDataTable';

import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    VDataTable,
    SnackBar,
  },
  data: () => ({
    dialog: false,
    search: '',
    headers: [
      {
        title: '#',
        align: 'start',
        key: 'id',
        sortable: false,
      },
      { title: 'Titulo', key: 'titulo' },
      { title: 'Data Início', key: 'dataInicio' },
      { title: 'Data Fim', key: 'dataFim' },
      { title: 'Ações', align: 'center', key: 'actions', sortable: false },
    ],
    avaliacoes: [],
    editedIndex: -1,
    editedItem: {
      titulo: '',
      dataInicio: '',
      dataFim: '',
    },
    defaultItem: {
      titulo: '',
      dataInicio: '',
      dataFim: '',
    },
  }),

  created() {
    this.idAvaliacao = this.$route.params.id;
    this.nomeProjeto = this.$route.params.nome;
    this.fetchavaliacoes();
  },

  methods: {
    // Função de inicialização de avaliações,
    // sempre preenche com uma req ao back
    /* eslint-disable */
    /**
     * Busca a lista de avaliações a partir do backend e preenche o array de avaliaçao
     * @function
     * @name fetchavaliacoes
     * @memberof RatingsList
     * @returns {Promise<void>}
     */
    fetchavaliacoes() {
      axios
        .get(API_URL + `/avaliacoes/${this.idAvaliacao}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          let count = 1;
          response.data.forEach((element) => {
            /* eslint-disable */
            element.fl_coordenador === true
              ? (element.fl_coordenador = 'Coordenador')
              : (element.fl_coordenador = 'Desenvolvedor');
            /* eslint-enable */

            const dtinicio = new Date(element.tb_avaliacao.dtinicio);
            const dtfim = new Date(element.tb_avaliacao.dtfim);

            this.avaliacoes.push({
              id: count++,
              idAval: element.tb_avaliacao.id_avaliacao,
              titulo: element.tb_avaliacao.titulo,
              dataInicio: `${dtinicio.getDate()}/${
                dtinicio.getMonth() + 1
              }/${dtinicio.getFullYear()}`,
              dataFim: `${dtfim.getDate()}/${
                dtfim.getMonth() + 1
              }/${dtfim.getFullYear()}`,
              idproj: element.id_projeto,
            });
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    /* eslint-disable */

    /**
     * Atualiza o estado de um item selecionado para ser editado e abre um diálogo para exibir as informações do item. Também faz uma requisição para obter os membros da equipe do item selecionado.
     *
     * @function showItem
     * @param {object} item - O objeto do item selecionado.
     * @returns {void}
     */
    showItem(item) {
      console.log(item.idproj);
    },
    parseDate(dateString) {
      var parts = dateString.split('/'); // Divide a string em partes usando '/'
      var day = parseInt(parts[0], 10); // Converte o dia em um número inteiro
      var month = parseInt(parts[1], 10) - 1; // Converte o mês em um número e subtrai 1 (janeiro é 0)
      var year = parseInt(parts[2], 10); // Converte o ano em um número inteiro
      return new Date(year, month, day); // Cria um objeto Date
    },
    callViewRating(item) {
      var dataAtual = new Date();
      console.log('titulo:', item.titulo);

      var ano = dataAtual.getFullYear(); // Retorna o ano (ex: 2023)
      var mes = dataAtual.getMonth() + 1; // Mês começa de 0 (janeiro) a 11 (dezembro), então adicionamos 1
      var dia = dataAtual.getDate(); // Retorna o dia do mês (1 a 31)
      var dataFormatada = dia + '/' + mes + '/' + ano;
      if (this.parseDate(item.dataFim) < this.parseDate(dataFormatada)) {
        var idAvaliacao = item.idAval;
        this.$router.push({
          name: 'allRatings360',
          params: {
            id: parseInt(idAvaliacao),
            id_proj: parseInt(item.idproj),
            titulo: item.titulo,
          },
        });
      } else {
        this.$refs.snackbar.showWarningSnackbar(
          'Atenção!',
          'O período para visualizar as respostas dessa avaliação ainda não começou.'
        );
      }
    },
    callViewRatingIndividual(item) {
      var idAvaliacao = item.idAval;
      this.$router.push({
        name: 'allRatingsIndividual',
        params: { id: parseInt(idAvaliacao), nomeAvaliacao: item.titulo, id_proj: parseInt(item.idproj), nomeProjeto: this.nomeProjeto },
      });
    },
  },
};
</script>
<style scoped>
.d-flex {
  display: flex;
}
.flex-wrap {
  flex-wrap: wrap;
}
</style>
